/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminProductOrders,
    AdminProductOrdersFromJSON,
    AdminProductOrdersFromJSONTyped,
    AdminProductOrdersToJSON,
} from './AdminProductOrders';

/**
 * 
 * @export
 * @interface AdminProductOrdersResp
 */
export interface AdminProductOrdersResp {
    /**
     * 
     * @type {Array<AdminProductOrders>}
     * @memberof AdminProductOrdersResp
     */
    items?: Array<AdminProductOrders>;
}

export function AdminProductOrdersRespFromJSON(json: any): AdminProductOrdersResp {
    return AdminProductOrdersRespFromJSONTyped(json, false);
}

export function AdminProductOrdersRespFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminProductOrdersResp {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : ((json['items'] as Array<any>).map(AdminProductOrdersFromJSON)),
    };
}

export function AdminProductOrdersRespToJSON(value?: AdminProductOrdersResp | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': !value.items ? undefined : ((value.items as Array<any>).map(AdminProductOrdersToJSON)),
    };
}

